<form class="sdp-saml-wizard-form" [formGroup]="form" novalidate>
	<div class="sdp-clear"></div>
	<div *ngIf="roleAttributes.controls.length > 0">
		<div class="sdp-saml-wizard-username-card">
			<div class="sdp-saml-wiard-username-inner-description">{{ "saml.wizard.username.group.description" | translate }}</div>
			<div formArrayName="roleAttributes">
				<div *ngFor="let attribute of roleAttributes.controls; let i = index">
					<div [formGroupName]="i" class="sdp-saml-group-attributes-form-control">
						<div class="sdp-form-control">
							<mat-form-field class="sdp-form-control-input-container sdp-saml-wizard-username-input-container-name">
								<input matInput placeholder="{{ 'saml.wizard.username.label.attribute.group' | translate }}" type="text" formControlName="attribute">
								<mat-error *ngIf="attribute.controls['attribute'].hasError('required')">{{ "error.form.groupAttribute" | translate }}</mat-error>
								<mat-error *ngIf="attribute.controls['attribute'].hasError('minlength')">{{ "error.form.groupAttribute" | translate }}</mat-error>
							</mat-form-field>
							<div *ngIf="i + 1 > requiredAttributeCount" class="sdp-saml-wizard-attribute-delete-icon-container">
								<sdp-icon (click)="deleteAttribute(i)" [icon]="deleteIcon"></sdp-icon>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="sdp-saml-wizard-user-attributes-add-attribute">
				<button class="sdp-button-small-text" (click)="addAttribute()" mat-raised-button type="button" color="accent">{{ "sdp.label.add" | translate }}</button>
			</div>
		</div>
	</div>
</form>